<!-- eslint-disable @typescript-eslint/no-empty-function -->
<template>
  <div class="AppReviewReport my-4">
    <div class="d-flex align-center my-3" style="width: 400px">
      <!-- <v-text-field
        outlined
        v-model="dashboardId"
        label="Dashboard Id"
        hide-details
      /> -->
      <!-- <v-btn color="primary" class="mx-2" @click="handleDashboardChange"
        >Show dashboard</v-btn
      > -->
    </div>
    <iframe style="width: 100%; height: 100vh" :src="iframeUrl" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
// import store, * as Store from '@/../src-gen/store';
import {InsightApi} from "../../../remote-api-point";

import axios from "axios";

import ModelVue from "@/components/ModelVue";
@Component({
  components: {
    
  },
})
export default class MetabaseDashboard extends ModelVue {
  iframeUrl: string = "";
  dashboardId = this.$route.params.dashboardId;
  public mounted() {
    this.generateMetabaseUrl();
  }

  handleDashboardChange() {
    if (this.dashboardId !== this.$route.params.dashboardId) {
      this.$router.push({
        name: "Root.Dashboard.MetabaseDashboard",
        params: { dashboardId: this.dashboardId, },
        query: {
          ...this.$route.query,
          clientfilenumber:"KFSINH-0123-123457"
        }
      });
    }
  }

  async generateMetabaseUrl() {
    const query = this.$route.query||{};
    
    const payload = await InsightApi.get(
      `/api/metabase/get-metabase-url?dashboardId=${this.dashboardId}`,
      {
        params:{params:JSON.stringify({...query})}
      }
    );
    this.iframeUrl = payload.data;
    console.log(payload.data);
  }
}
</script>

<style>
</style>
